import {createBaseShape} from './createBaseShape'
export const createArrow = (attrs) => {
  let strokeSize = 2
  let strokeColor = 'black'
  let fillColor = 'black'

  if (typeof window.strokeSize !== 'undefined') {
    strokeSize = window.strokeSize
  }

  if (typeof window.strokeColor !== 'undefined') {
    strokeColor = window.strokeColor
  }

  if (typeof window.fillColor !== 'undefined') {
    fillColor = window.fillColor
  }

  return Object.assign(
    createBaseShape({
      enabledAnchors: [
        'middle-left',
        'middle-right',
        'top-center',
        'bottom-center'
      ],
      shapeType: attrs.shapeType
    }),
    {
      points: [attrs.x, attrs.y, attrs.x + attrs.width, attrs.y],
      name: 'connector',
      pointerLength: 10,
      pointerWidth: 10,
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeSize
    }
  )
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/createArrow.js